import { environment } from "@/environments/environment";
import { getAccessToken } from "@/utils/auth-token";
import axios from "axios";

import { HttpGateway } from "@/features/authentication/infrastructure/services/http";

const httpImplementation: HttpGateway = axios.create({
  baseURL: environment.apiUrl
});

httpImplementation.interceptors.request.use(
  async (config) => {
    const token = await getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  async (error: any) => {
    return Promise.reject(error);
  }
);

export default httpImplementation;
